import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import type { Partner, PartnerReport } from '../../../types/partners';
import { Dialog } from '../../ui/Dialog';
import { TryPlatformButton } from '../TryPlatformButton';
import { DownloadButton } from '../DownloadButton';
import { PARTNER_BUTTON_CLASS } from './PartnerProfileHero';
type ReportPreviewModalProps = {
  partner: Partner;
  report: PartnerReport | null;
  onClose: () => void;
};
export function ReportPreviewModal({
  partner,
  report,
  onClose
}: ReportPreviewModalProps) {
  return <Dialog open={Boolean(report)} onClose={onClose} labelledBy="report-preview-title" className="flex max-h-[92vh] max-w-[1000px] flex-col overflow-hidden" data-id="element-746" data-mp="1q14cwl6hk98a">
      {report ? <>
          <div className="flex items-center justify-between gap-4 border-b border-hairline px-5 py-3" data-id="element-747" data-mp="1zr754j5s9j5k">
            <div className="min-w-0" data-id="element-748" data-mp="23vokm6541aaj">
              <h2 id="report-preview-title" className="truncate text-base font-semibold text-text-primary" data-id="element-749" data-mp="28t6kl715gf6e">
                {report.title} report
              </h2>
              <p className="text-xs text-text-tertiary" data-id="element-750" data-mp="y96wzkd99f0s">Example report supplied by {partner.name}</p>
            </div>
            <button type="button" onClick={onClose} aria-label="Close report preview" className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-text-tertiary hover:bg-elevated hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-751" data-mp="u84vsxzs2sw6">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-752" data-mp="1cx1ude27k7k7" />
            </button>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto bg-elevated p-3 sm:p-6" data-id="element-753" data-mp="184ie29c4yybp">
            <div className="mx-auto grid max-w-[920px] gap-6 lg:grid-cols-[minmax(0,1fr)_220px] lg:items-start" data-id="element-754" data-mp="135p2wnkbnjep">
              <img src={report.image.src} alt={report.image.alt} width={report.image.width} height={report.image.height} decoding="async" className="h-auto w-full rounded-xl bg-panel shadow-md" data-id="element-755" data-mp="20mw2jibl17y4" />
              <div data-id="element-756" data-mp="3u4bmyp00x5fo">
                <p className="text-sm leading-relaxed text-text-secondary" data-id="element-757" data-mp="3u6xpubbyywrk">{report.description}</p>
                {report.highlights?.length ? <ul className="mt-4 flex flex-col gap-2" data-id="element-758" data-mp="3lbq478we6yqu">
                    {report.highlights.map(point => <li key={point} className="flex items-start gap-2 text-sm text-text-primary" data-id="element-759" data-mp="36ehcge36fsyl">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--pa)]" aria-hidden="true" data-id="element-760" data-mp="3bf52awfo63r8" />
                        {point}
                      </li>)}
                  </ul> : null}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-3 border-t border-hairline px-5 py-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-761" data-mp="voirq1n4gk5g">
            <p className="text-xs text-text-tertiary" data-id="element-762" data-mp="10k7u0cqj0f5g">AI-generated analysis for information only — not legal advice.</p>
            <div className="flex gap-2" data-id="element-763" data-mp="15r4lvehia544">
              <DownloadButton partner={partner} url={report.image.src} fileName={report.downloadName} documentId={report.id} ariaLabel={`Download the ${report.title} example report`} className="min-h-[44px] flex-1 sm:flex-none" data-id="element-764" data-mp="15s79ndjj7rft" />
              <TryPlatformButton partner={partner} placement={`report_modal_${report.id}`} label={partner.tryLabel} className={`flex-1 sm:flex-none ${PARTNER_BUTTON_CLASS}`} data-id="element-765" data-mp="1titfcy62czmn" />
            </div>
          </div>
        </> : null}
    </Dialog>;
}